import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import Label from "../label/label";
import Description from "../description/Description";

const ReasonCodeCard: FC = () => {
    const { values, errors } = useFormikContext<any>();
    const { translate } = useLocale();

    return (
        <div className="w-full overflow-visible">
            <div className="flex flex-col py-4 px-8">
                <div className="mb-4">
                    <div className="flex flex-row justify-between">
                        <Label
                            htmlFor="name"
                            className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                        {errors.name ? <span className='text-red-600 text-xs'>{errors.name}</span> : null}
                    </div>
                    <div id="reasonCodeInputTextArea">
                        <Description
                            accessor="name"
                            title=""
                            isRequired={true} />
                    </div>
                </div>
            </div>
        </div>)
}

export default ReasonCodeCard;
